import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'landing',
    component: () => import('@/views/landing/LandingPage.vue'),
    meta: { public: true, title: '普惠小微' },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/LoginPage.vue'),
    meta: { public: true, title: '登录' },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/auth/RegisterPage.vue'),
    meta: { public: true, title: '注册' },
  },
  {
    path: '/',
    component: () => import('@/layouts/DefaultLayout.vue'),
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/DashboardPage.vue'),
        meta: { title: '工作台' },
      },
      {
        path: 'bookkeeping',
        name: 'bookkeeping',
        component: () => import('@/views/bookkeeping/BookkeepingPage.vue'),
        meta: { title: '智能记账' },
      },
      {
        path: 'tax',
        name: 'tax',
        component: () => import('@/views/tax/TaxPage.vue'),
        meta: { title: '税务自查' },
      },
      {
        path: 'cashflow',
        name: 'cashflow',
        component: () => import('@/views/cashflow/CashflowPage.vue'),
        meta: { title: '现金流预警' },
      },
      {
        path: 'credit',
        name: 'credit',
        component: () => import('@/views/credit/CreditPage.vue'),
        meta: { title: '普惠信贷' },
      },
      {
        path: 'risk',
        name: 'risk',
        component: () => import('@/views/risk/RiskPage.vue'),
        meta: { title: '风险筛查' },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundPage.vue'),
    meta: { public: true, title: '页面未找到' },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach((to) => {
  // Mock 模式下不做鉴权拦截，便于直接体验控制台各模块
  return true
})

router.afterEach((to) => {
  const title = (to.meta.title as string) || ''
  document.title = title ? `${title} | 普惠小微` : '普惠小微'
})

export default router
